import cn from 'classnames';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@components/shared';
import s from '../FullWidthLightbox.module.less';

type DownloadImageTypes = {
  disabled?: boolean;
  imageUrl: string;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
  onClick: () => void;
};

const DownloadImage = ({
  disabled,
  imageUrl,
  onMouseOver = () => null,
  onMouseLeave = () => null,
  onClick,
}: DownloadImageTypes) => {
  const { t } = useTranslation('listing');
  return (
    <Tooltip placement="topLeft" trigger={['hover']} title={t('gallery.downloadImageTooltip')}>
      <a
        href={imageUrl}
        aria-label="download image"
        download
        onClick={onClick}
        className={cn([s.downloadButton, s.downloadImageButton, disabled && s.disabled])}
      >
        <IconButton
          icon="download2"
          disabled={disabled}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        />
      </a>
    </Tooltip>
  );
};

export default DownloadImage;
